var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"main"},[_c('Sider',{staticClass:"sider",attrs:{"hide-trigger":""}},[_c('SiderPreviewCard')],1),_c('Content',{staticClass:"content"},[_c('MainPreviewCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }